module.exports = __webpack_public_path__ + "static/image/main/season_1_character_docgo.png?bc398432";